import ImageGallery from "./ImageGallery";
import EmbedVideo from "./EmbedVideo";
import Lecture from "./Lecture";

const components = {
  images: ImageGallery,
  embed_video: EmbedVideo,
  english_lectures: Lecture,
  greek_lectures: Lecture,
};

export default components;
